import { useEffect, useState } from "react";
// react redux
import { useSelector } from "react-redux";
// hooks
import usePageParams from "../../hooks/usePageParams";
// axios
import EnhancedAxios from "../../axios/EnhancedAxios";
import { AxiosResponse, AxiosError } from "axios";
// mui
import { Stack, Box } from "@mui/material";
// components
import {
    PageTitle,
    SortBox,
    SearchBox,
    TableGrid,
    ThreeDotsLoader,
    StatusFilterBox,
    LinkButton,
} from "../../components";
import { operatorsCols } from "../../utils/gridCols/operatorsCols";
import { errorAlert } from "../../utils/alerts/alerts";
// global state  type
import { ReduxUserReducerState } from "../../types/global";
import { MdAdd } from "react-icons/md";
const Operators = () => {
    const userToken = useSelector(
        (state: ReduxUserReducerState) => state.user.userToken
    );
    const { page, setPage } = usePageParams();
    const [operators, setOperators] = useState([]);
    const [sortValue, setSortValue] = useState<string>("-created_at");
    const [searchValue, setSearchValue] = useState("");
    const [itemsPerPage, setItemsPerPage] = useState(24);
    const [totalItems, setTotalItems] = useState(10);
    const [loading, setLoading] = useState(true);
    const [filterValues, setFilterValues] = useState({
        status: "",
    });
    // get all users
    useEffect(() => {
        setLoading(true);
        EnhancedAxios(null, userToken)
            .get(
                `/admin/users?page=${page}&paginate=${itemsPerPage}&sorts=${sortValue}&q=${searchValue}&filters=${filterValues.status},roles:ex:5`
            )
            .then((res: AxiosResponse) => {
                setOperators(res.data.data);
                setTotalItems(res.data.meta.total);
                setLoading(false);
            })
            .catch((error: AxiosError) => {
                errorAlert(error);
            });
    }, [page, sortValue, searchValue, filterValues]);
    return (
        <Stack gap="20px">
            <PageTitle title="ادراة المشغلين" />
            <LinkButton to="/add-operator" icon={<MdAdd />} />
            <Box
                display="flex"
                justifyContent="center"
                alignItems="center"
                gap="10px"
                flexWrap="wrap"
            >
                <SearchBox
                    searchValue={searchValue}
                    setSearchValue={setSearchValue}
                />
                <SortBox sortValue={sortValue} setSortValue={setSortValue} />
                <StatusFilterBox
                    filterValues={filterValues}
                    setFilterValues={setFilterValues}
                />
            </Box>
            {loading ? (
                <ThreeDotsLoader />
            ) : operators.length === 0 ? (
                <p className="center-text">لا يوجد مشغلين لعرضهم</p>
            ) : (
                <TableGrid
                    rows={operators}
                    cols={operatorsCols}
                    itemsPerPage={itemsPerPage}
                    totalItems={totalItems}
                    currentPage={page}
                    setCurrentPage={setPage}
                />
            )}
        </Stack>
    );
};

export default Operators;
